import { createExperimentHook } from 'src/components/experiment';

export const useKWLPLimitProducts = createExperimentHook(
  'kwlp-limit-products',
  100,
  {
    items24: 24,
    items48: 48,
  }
);
export const useStrictSearch = createExperimentHook('strict-search', false, {
  strict: true,
});

export const useKWLPDeprioritizeNoImageOffers = createExperimentHook(
  'kwlp-deprioritize-no-image-offers',
  false,
  {
    deprioritize: true,
  }
);

export const useShowAllVariantsExperiment = createExperimentHook(
  'show-all-variants',
  false,
  {
    show: true,
  }
);

export type useNewPriceHistoryExperimentType =
  | boolean
  | 'new-using-old-data-source'
  | 'new-using-new-data-source';

export const useNewPriceHistoryExperiment =
  createExperimentHook<useNewPriceHistoryExperimentType>(
    'price-history-new',
    false,
    {
      newUi: 'new-using-old-data-source',
      newUiAndDataSource: 'new-using-new-data-source',
    }
  );

export const useWideCategoryTableExperiment = createExperimentHook(
  'wide-category-table',
  false,
  {
    wide: true,
  }
);

export const useProductRelationsExperiment = createExperimentHook(
  'product-relations',
  false,
  {
    show: true,
  }
);

export const useSearchPageFilterSortingExperiment = createExperimentHook(
  'search-page-filter-sorting',
  false,
  {
    show: true,
  }
);
